import { render } from "./PlaybooksDashboard.vue?vue&type=template&id=3a25e696&scoped=true"
import script from "./PlaybooksDashboard.vue?vue&type=script&lang=js"
export * from "./PlaybooksDashboard.vue?vue&type=script&lang=js"

import "./PlaybooksDashboard.vue?vue&type=style&index=0&id=3a25e696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a25e696"]])

export default __exports__